import styles from "./YouveViewed.module.scss";
import classNames from "classnames/bind";

const cx = classNames.bind(styles);

const YOUVE_VIEWED_FREQUENCY = 24;
const YOUVE_VIEWED_FREQUENCY_DESKTOP = 72;

export function YouveViewed({
  resultsInfo,
  numProductsOnPageAbove,
}: {
  resultsInfo: {
    start: number;
    total: number;
    pageSize: number;
  };
  numProductsOnPageAbove: number;
}) {
  if (!resultsInfo.total) {
    return null;
  }

  const numProductsViewed = resultsInfo.start + numProductsOnPageAbove;
  const isEndOfFullPage = numProductsOnPageAbove === resultsInfo.pageSize;
  const isEndOfResults = numProductsViewed === resultsInfo.total;
  const isEndOfPage = isEndOfFullPage || isEndOfResults;

  const isCorrectFrequency =
    numProductsOnPageAbove % YOUVE_VIEWED_FREQUENCY === 0;
  const isSmallBreakpointOnly =
    isCorrectFrequency &&
    numProductsOnPageAbove % YOUVE_VIEWED_FREQUENCY_DESKTOP !== 0;

  if (!isEndOfPage && !isCorrectFrequency) {
    return null;
  }

  return (
    <small
      data-component="YouveViewed"
      className={cx("youveViewed", {
        ["youveViewed--mobileOnly"]: !isEndOfPage && isSmallBreakpointOnly,
      })}
      data-testid={`youve-viewed${isEndOfPage ? "-page-end" : ""}`}
    >
      {`You've viewed ${numProductsViewed.toLocaleString(
        "en",
      )} of ${resultsInfo.total.toLocaleString("en")} items`}
    </small>
  );
}
